import React, { useState, useEffect } from 'react';
import Navbar from '../layout/Navbar';
import Footer from '../layout/Fotter';
import BathroomTils from '../../assets/bathrrom-tils.avif';
import BathrromTilsRoom from '../../assets/bathrrom-tils-room.webp';
import BathroomTils1 from '../../assets/bathrrom-tils-1.avif';
import BathroomTils3 from '../../assets/bathrrom-tils-3.jpg';
import BathroomTils4 from '../../assets/bathrrom-tils-4.webp';
import BathroomTilsWhite from '../../assets/bathrrom-tils-white.jpg';
import BathroomTilsWhite1 from '../../assets/bathrrom-tils-white-1.webp';
import BathroomTilsWhite2 from '../../assets/bathrrom-tils-white-2.webp';
import BathroomTilsWhite4 from '../../assets/bathrrom-tils-white-4.webp';
import BathrromTilsWooden from '../../assets/bathrrom-tils-wooden.webp';
import BathrromTilsWooden1 from '../../assets/bathrrom-tils-wooden-1.webp';
import BathrromTilsWooden2 from '../../assets/bathrrom-tils-wooden-2.webp';
import BathrromTilsWooden3 from '../../assets/bathrrom-tils-wooden-3.webp';
import BathrromTilsGray from '../../assets/bathrrom-tils-gray.webp';
import BathrromTilsGray1 from '../../assets/bathrrom-tils-gray-1.jpeg';
import BathrromTilsGray2 from '../../assets/bathrrom-tils-gray-2.webp';
import BathrromTilsGray3 from '../../assets/bathrrom-tils-gray-3.jpeg';
import BathrromTilsLightGray from '../../assets/bathrrom-tils-light-gray.avif';
import BathrromTilsLightGray1 from '../../assets/bathrrom-tils-light-gray-1.jpg';
import BathrromTilsLightGray2 from '../../assets/bathrrom-tils-light-gray-2.webp';
import BathrromTilsLightGray3 from '../../assets/bathrrom-tils-light-gray-3.webp';
import { Biohazard, Droplets, Footprints, Shield } from 'lucide-react';

const Bathroom = () => {
  // State for modal
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [isImageLoading, setIsImageLoading] = useState(true);

  // Function to open modal with selected image
  const openModal = (image, title) => {
    setIsImageLoading(true);
    setSelectedImage({ src: image, title });
    setIsModalOpen(true);
  };

  // Function to close modal
  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedImage(null);
    setIsImageLoading(true);
  };

  // Handle outside click to close modal
  const handleOutsideClick = (e) => {
    if (e.target === e.currentTarget) {
      closeModal();
    }
  };

  // Handle keyboard accessibility and prevent body scroll
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') {
        closeModal();
      }
    };
    if (isModalOpen) {
      document.body.style.overflow = 'hidden';
      window.addEventListener('keydown', handleKeyDown);
    } else {
      document.body.style.overflow = 'auto';
    }
    return () => {
      document.body.style.overflow = 'auto';
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [isModalOpen]);

  // Bathroom carving tiles collection data - Modified structure
  const bathroomCollections = [
    {
      id: 1,
      name: "AQUA CHOCO",
      mainBathroomImage: BathroomTils,
      tileImages: [BathroomTils1, BathroomTils3, BathroomTils4],
      size: "80x240mm",
      finish: "Carving Glossy",
      description: "Sleek white tiles with subtle wave patterns, perfect for modern bathroom aesthetics.",
      features: ["Anti-Slip Surface", "Water Resistant", "Mold Resistant", "Easy to Clean"],
    },
    {
      id: 2,
      name: "PRISTINE WHITE",
      mainBathroomImage: BathroomTilsWhite,
      tileImages: [BathroomTilsWhite1, BathroomTilsWhite2, BathroomTilsWhite4],
      size: "120x80mm",
      finish: "Carving Glossy",
      description: "Elegant white tiles with sophisticated carving details for luxury bathrooms.",
      features: ["Anti-Slip Surface", "Water Resistant", "Mold Resistant", "Easy to Clean"],
    },

    {
      id: 3,
      name: "PRISTINE WOODEN",
      mainBathroomImage: BathrromTilsWooden,
      tileImages: [BathrromTilsWooden1, BathrromTilsWooden2, BathrromTilsWooden3],
      size: "13x80mm",
      finish: "Carving Glossy",
      description: "Elegant wooden tiles with sophisticated carving details for luxury bathrooms.",
      features: ["Anti-Slip Surface", "Water Resistant", "Mold Resistant", "Easy to Clean"],
    },

    {
      id: 4,
      name: "PRISTINE GRAY",
      mainBathroomImage: BathrromTilsGray,
      tileImages: [BathrromTilsGray1, BathrromTilsGray2, BathrromTilsGray3],
      size: "29x180mm",
      finish: "Carving Glossy",
      description: "Elegant gray tiles with sophisticated carving details for luxury bathrooms.",
      features: ["Anti-Slip Surface", "Water Resistant", "Mold Resistant", "Easy to Clean"],
    },

    
    {
      id: 5,
      name: "PRISTINE LIGHT GRAY",
      mainBathroomImage: BathrromTilsLightGray,
      tileImages: [BathrromTilsLightGray1, BathrromTilsLightGray2, BathrromTilsLightGray3],
      size: "40x40mm",
      finish: "Carving Glossy",
      description: "Elegant light gray tiles with sophisticated carving details for luxury bathrooms.",
      features: ["Anti-Slip Surface", "Water Resistant", "Mold Resistant", "Easy to Clean"],
    },
  ];

  const bathroomCategory = {
    fullName: "Bathroom Carving Finish Tiles",
    description:
      "Premium carving finish tiles designed specifically for bathrooms, offering a blend of style, durability, and slip resistance for wet environments.",
    features: ["Water Absorption < 0.5%", "Anti-Slip Technology", "Mold and Mildew Resistant", "High Durability"],
    sizes: ["19.5x120mm", "80x260mm", "30x30mm", "100x100mm"],
  };

  return (
    <div className="w-full overflow-hidden">
      {/* Navbar */}
      <Navbar />

      {/* Hero Section */}
  <section className="relative h-[50vh] sm:h-[60vh] md:h-[70vh] lg:h-[80vh] bg-gradient-to-r from-gray-900 via-gray-800 to-orange-900">
        <div
          className="absolute inset-0 bg-cover bg-center bg-no-repeat"
          style={{ backgroundImage: `url(${BathrromTilsRoom})` }}
        ></div>
        <div className="absolute inset-0 bg-black bg-opacity-50"></div>
        <div className="relative z-10 h-full flex items-center justify-center">
          <div className="text-center text-white max-w-full sm:max-w-2xl md:max-w-3xl lg:max-w-4xl px-4 sm:px-6">
            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-orange-500 mb-4 sm:mb-6 drop-shadow-2xl">
              Bathroom Carving Collection
            </h1>
            <p className="text-base sm:text-lg md:text-xl lg:text-2xl font-light">
              {bathroomCategory.fullName}
            </p>
            <div className="mt-4 sm:mt-6 w-24 sm:w-28 lg:w-32 h-1 bg-orange-500 mx-auto"></div>
          </div>
        </div>
      </section>

      {/* Product Info Section */}
      <section className="py-8 sm:py-12 lg:py-16 bg-white">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-8 sm:mb-12 lg:mb-16">
            <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800 mb-3 sm:mb-4">
              Premium <span className="text-orange-600">Bathroom Tiles</span>
            </h2>
            <p className="text-sm sm:text-base md:text-lg text-gray-600 max-w-2xl sm:max-w-3xl lg:max-w-4xl mx-auto mb-6 sm:mb-8 leading-relaxed">
              {bathroomCategory.description} Our bathroom tiles are engineered for safety and style, perfect for wet and humid environments.
            </p>
            {/* Features */}
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6 max-w-5xl mx-auto">
              {bathroomCategory.features.map((feature, index) => (
                <div
                  key={index}
                  className="bg-gradient-to-br from-orange-50 to-orange-100 p-4 sm:p-6 rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300"
                >
                  <div className="bg-orange-600 text-white text-lg sm:text-xl md:text-2xl w-10 h-10 sm:w-12 sm:h-12 rounded-full flex items-center justify-center mx-auto mb-3 sm:mb-4">
                    ✓
                  </div>
                  <p className="text-gray-800 font-semibold text-sm sm:text-base md:text-lg">{feature}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Modified Bathroom Collection Gallery */}
      <section className="py-8 sm:py-12 lg:py-16 bg-gray-50">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-8 sm:mb-12 lg:mb-16">
            <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800 mb-3 sm:mb-4">
              Our <span className="text-orange-600">Bathroom Collections</span>
            </h2>
            <p className="text-base sm:text-lg md:text-xl text-gray-600 max-w-2xl sm:max-w-3xl mx-auto">
              Discover our range of carving finish tiles designed to elevate your bathroom with elegance and functionality.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 sm:gap-10 lg:gap-12">
            {bathroomCollections.map((collection) => (
              <div key={collection.id} className="bg-white rounded-xl shadow-2xl overflow-hidden flex flex-col">
                {/* Collection Header */}
                <div className="bg-gradient-to-r from-orange-600 to-orange-700 text-white p-4 sm:p-6">
                  <h3 className="text-lg sm:text-xl md:text-2xl lg:text-3xl font-bold text-center">{collection.name}</h3>
                </div>

                <div className="p-4 sm:p-6 flex-1 flex flex-col">
                  {/* Main Bathroom Image */}
                  <div className="relative group mb-6">
                    <div className="relative w-full h-48 sm:h-56 md:h-64 overflow-hidden rounded-2xl">
                      <img
                        src={collection.mainBathroomImage}
                        alt={`${collection.name} bathroom scene`}
                        className="w-full h-full object-cover rounded-2xl cursor-pointer"
                        loading="lazy"
                        onClick={() => openModal(collection.mainBathroomImage, `${collection.name} - Bathroom Scene`)}
                      />
                      <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 rounded-2xl"></div>
                      <div className="absolute bottom-3 sm:bottom-4 left-3 sm:left-4 text-white opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                        <h4 className="text-sm sm:text-base md:text-lg font-bold mb-1">{collection.name}</h4>
                        <p className="text-xs bg-black/50 px-2 py-1 rounded-full">Bathroom Application</p>
                      </div>
                    </div>
                  </div>

                  {/* Size Information */}
                  <div className="text-center mb-6">
                    <div className="inline-flex items-center bg-gradient-to-r from-orange-100 to-orange-200 text-orange-800 font-bold py-3 px-6 rounded-xl shadow-lg">
                      <span className="text-xl mr-2">📏</span>
                      <span className="text-lg md:text-xl">Size: {collection.size}</span>
                    </div>
                  </div>

                  {/* Tile Images Grid */}
                  <div className="grid grid-cols-2 sm:grid-cols-3 gap-4 mb-6">
                    {collection.tileImages.map((tileImage, tileIndex) => (
                      <div key={tileIndex} className="relative cursor-pointer">
                        <div className="relative w-full h-48 sm:h-56 md:h-64 max-w-[340px] mx-auto overflow-hidden rounded-2xl shadow-md">
                          <img
                            src={tileImage}
                            alt={`${collection.name} tile design ${tileIndex + 1}`}
                            className="w-full h-full object-cover rounded-2xl"
                            onClick={() => openModal(tileImage, `${collection.name} - Design ${tileIndex + 1}`)}
                            loading="lazy"
                          />
                        </div>
                      </div>
                    ))}
                  </div>

                  {/* Collection Details */}
                  <div className="border-t pt-6">
                    <p className="text-sm sm:text-base text-gray-600 mb-3 sm:mb-4 leading-relaxed">{collection.description}</p>
                    <div className="flex flex-wrap gap-2 sm:gap-3 mb-3 sm:mb-4">
                      <span className="bg-orange-100 text-orange-800 text-xs sm:text-sm px-2 sm:px-3 py-1 rounded-full">
                        Finish: {collection.finish}
                      </span>
                    </div>
                    <ul className="text-sm sm:text-base text-gray-600 space-y-1 sm:space-y-2">
                      {collection.features.map((feature, index) => (
                        <li key={index} className="flex items-center">
                          <span className="text-orange-600 mr-2">✓</span> {feature}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Available Sizes Section */}
      <section className="py-8 sm:py-12 lg:py-16 bg-white">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-8 sm:mb-12">
            <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800 mb-3 sm:mb-4">
              Available <span className="text-orange-600">Sizes</span>
            </h2>
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 sm:gap-4 lg:gap-6 max-w-2xl sm:max-w-3xl lg:max-w-4xl mx-auto">
              {bathroomCategory.sizes.map((size, index) => (
                <div
                  key={index}
                  className="bg-gradient-to-br from-orange-100 to-orange-200 text-orange-800 font-bold py-3 sm:py-4 px-4 sm:px-6 rounded-xl text-center shadow-lg hover:shadow-xl transition-shadow duration-300 transform hover:-translate-y-1"
                >
                  <div className="text-lg sm:text-xl md:text-2xl mb-1 sm:mb-2">📏</div>
                  <div className="text-sm sm:text-base md:text-lg">{size}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Technical Specifications */}
      <section className="py-8 sm:py-12 lg:py-16 bg-gray-50">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-8 sm:mb-12">
            <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800 mb-3 sm:mb-4">
              Technical <span className="text-orange-600">Specifications</span>
            </h2>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 lg:gap-8 max-w-2xl sm:max-w-4xl lg:max-w-6xl mx-auto">
            {[
              { icon:<Droplets className='mx-auto h-7 w-7 sm:h-10 sm:w-10' />, title: "Water Absorption", desc: "Less than 0.5% as per IS 15622" },
              { icon:<Shield className='mx-auto h-7 w-7 sm:h-10 sm:w-10' />, title: "Slip Resistance", desc: "R10 rating for safe bathroom use" },
              { icon:<Biohazard className='mx-auto h-7 w-7 sm:h-10 sm:w-10' />, title: "Mold Resistance", desc: "Resistant to mold and mildew growth" },
            ].map((spec, index) => (
              <div key={index} className="bg-white hover:bg-gray-50 p-4 sm:p-6 rounded-xl shadow-lg">
                <div className="text-orange-600 text-2xl sm:text-3xl md:text-4xl mb-3 sm:mb-4 text-center">{spec.icon}</div>
                <h3 className="text-base sm:text-lg md:text-xl font-bold text-gray-800 mb-2 text-center">{spec.title}</h3>
                <p className="text-sm sm:text-base text-gray-600 text-center">{spec.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="py-8 sm:py-12 lg:py-16 bg-gradient-to-r from-orange-600 to-orange-700">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-3 sm:mb-4">
            Transform Your Bathroom Today
          </h2>
          <p className="text-base sm:text-lg md:text-xl text-orange-100 mb-6 sm:mb-8 max-w-2xl sm:max-w-3xl mx-auto leading-relaxed">
            Contact our design experts to find the perfect carving finish tiles for your bathroom. Get personalized recommendations and professional installation support.
          </p>
        </div>
      </section>

      {/* Modal for Image Zoom */}
      {isModalOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center z-50 p-2 sm:p-4"
          onClick={handleOutsideClick}
        >
          <div className="relative w-full max-w-[95vw] sm:max-w-4xl md:max-w-5xl lg:max-w-6xl max-h-[90vh] mx-auto flex items-center justify-center">
            {isImageLoading && (
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="w-12 sm:w-14 lg:w-16 h-12 sm:h-14 lg:h-16 border-4 border-orange-600 border-t-transparent rounded-full animate-spin"></div>
              </div>
            )}
            <img
              src={selectedImage.src}
              alt={`Zoomed view of ${selectedImage.title}`}
              className="w-[500px] h-[400px] sm:w-[600px] sm:h-[500px] md:w-[700px] md:h-[600px] object-cover rounded-lg shadow-2xl mx-auto"
              style={{ maxWidth: '90vw', maxHeight: '80vh' }}
              onLoad={() => setIsImageLoading(false)}
            />
            <button
              onClick={closeModal}
              className="absolute top-2 sm:top-3 right-2 sm:right-3 bg-white text-black rounded-full p-2 sm:p-3 hover:bg-gray-200 transition-all duration-300 text-base sm:text-lg lg:text-xl font-bold shadow-lg"
            >
              ✕
            </button>
            {selectedImage && !isImageLoading && (
              <div className="absolute bottom-2 sm:bottom-3 left-2 sm:left-4 bg-black/70 text-white px-3 sm:px-4 py-1 sm:py-2 rounded-lg">
                <h3 className="text-sm sm:text-base md:text-lg font-bold">{selectedImage.title}</h3>
              </div>
            )}
          </div>
        </div>
      )}

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default Bathroom;